import axios from 'axios'
import { registerUrl } from '@/plugins/auth'
import { buildUrl } from '@/services/path'
import { LRUMap } from 'lru_map'

const GEOLOCATION_API_URL = buildUrl(process.env.VUE_APP_MAIN_UI_API_URL, '/api/v1/geoip')
registerUrl(GEOLOCATION_API_URL)

const GEOLOCATION_CACHE_SIZE = 1000
const GEOLOCATION_CACHE = new LRUMap<string, object>(GEOLOCATION_CACHE_SIZE)

export default {
  /**
   * Fetch geolocation from an ip address.
   *
   * @param ip address.
   * @returns A promise resolving the geolocation.
   */
  getGeoLocationFromIp (ip: string) {
    let cached = GEOLOCATION_CACHE.get(ip)
    if (cached === undefined) {
      cached = axios.get(buildUrl(GEOLOCATION_API_URL, ip))
        .then((resp) => {
          const data = resp.data
          GEOLOCATION_CACHE.set(ip, data)
          return data
        }).catch((err) => {
          GEOLOCATION_CACHE.delete(ip)
          throw err
        })
      GEOLOCATION_CACHE.set(ip, cached)
      return cached
    } else {
      return Promise.resolve(cached)
    }
  }
}
